import tempStorage from 'usage-tracker-core/containers/tempStorage';
import { makeUuid } from 'usage-tracker-core/common/helpers';
import { hamplitudeKey } from 'usage-tracker-core/storageKeys';
import { createTracker } from 'usage-tracker-anonymous';
import { getUuid } from '../utils';
export default {
  init: (options, {
    location
  }) => {
    const tracker = createTracker(options);
    tracker.setProperties({
      deviceId: getUuid(location)
    });
    return tracker;
  },
  switch: (_, {
    location,
    replace
  }) => {
    let uuidQueryParam = getUuid(location); // Validates if either an existing UUID is present or not
    // or if it has some sort of weird format (should always be smaller or equal than 64 characters)

    if (uuidQueryParam === undefined || uuidQueryParam.length > 64) {
      uuidQueryParam = makeUuid();
    }

    const searchParams = new URLSearchParams(location.search);
    searchParams.set('uuid', uuidQueryParam);
    replace(`${location.pathname}?${searchParams}`); // Clears the Amplitude Storage as when switching to Anonymosu Tracking
    // we should clear out the user information
    // If the user happens to switch back to authed tracker, a new device_id
    // and a new session_id will be generated
    // Note: This is a temporary measure until teams adopt Anonymous Tracking correctly

    tempStorage.removeItem(hamplitudeKey);
  }
};